<div
  class="flex justify-between w-full items-center h-20 bg-zinc-100 dark:bg-zinc-950 text-zinc-900 dark:text-zinc-50 px-4 sm:!px-6 lg:!px-8 ">
  <div id="header-left" class="flex items-center gap-3">

    <fv-avatar [border]="FV_AVATAR_BORDER.full" [size]="FV_AVATAR_SIZE.sm" [src]="image === 'undefined' ? '' : image"
      class="align-middle">
    </fv-avatar>

    <div id="logo-info" class="pointer-events-none">

      <div *ngIf="organization?.tipo === 'equipo' "
        class="text-2xs text-zinc-400 dark:text-zinc-300 relative -top-1 capitalize">
        {{ organization?.tipo }}
      </div>

      <div
        class="text-md sm:!text-lg text-zinc-900 dark:text-zinc-50 font-semibold truncate max-w-[150px] sm:max-w-none">
        {{ organization?.nombre }}
      </div>

      <div class="flex gap-2">
        <div class="flex gap-2 items-center text-2xs text-zinc-400 capitalize"
          [ngClass]="{'dark:text-red-300': !isInternetConnected}">
          <span *ngIf="isInternetConnected" class="w-2 h-2 dark:bg-green-300 bg-green-400 rounded-full"></span>
          <span *ngIf="!isInternetConnected" class="w-2 h-2 dark:bg-red-300 bg-red-400rounded-full"></span>
          <span>{{ device?.name | uppercase }}</span>
        </div>

        <div *ngIf="isMocksEnabled" class=" flex gap-2 text-2xs text-zinc-400 dark:text-red-300 capitalize">
          {{ 'MOCKS ACTIVATED' }}
        </div>
      </div>

    </div>
  </div>
  <div id="header-right" class="flex space-x-2.5 sm:!space-x-4 items-center text-sm">

    <app-clock></app-clock>

    <div *ngIf="isDevEnvironment() || isHelperActivatedFlag()" id="in-context-log"
      (click)="onClickConfigurationDropdown($event)" class="rounded-full border-2 border-orange-500 opacity-50 bg-white dark:bg-zinc-900 dark:text-white cursor-pointer h-8 w-8 flex items-center justify-center
    relative">
      <i class="far fa-gears"></i>
    </div>

    <div id="menu-button" (click)="onClickHeaderDropdown($event)" data-cy="header-menu" class="rounded-full bg-white dark:bg-zinc-900 dark:text-white
       transition-colors cursor-pointer h-8 w-8 flex items-center justify-center
      relative">
      <i id="contextual-menu" class="fas fa-ellipsis-v"></i>
    </div>
  </div>
</div>